import React from 'react';
import { Heart } from 'lucide-react';

export default function BlissfulBond() {
  return (
    <div className="ubuntu bg-white font-sans text-black">
      <nav className="fixed top-0 z-50 w-full border-b border-gray-300 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <div className="text-xl font-bold">K & M</div>
            <div className="hidden space-x-6 md:flex">
              <a href="#hero" className="transition hover:text-gray-700">
                Home
              </a>
              <a href="#about" className="transition hover:text-gray-700">
                About Us
              </a>
              <a href="#story" className="transition hover:text-gray-700">
                Our Story
              </a>
              <a href="#gallery" className="transition hover:text-gray-700">
                Gallery
              </a>
              <a href="#events" className="transition hover:text-gray-700">
                Events
              </a>
              <a href="#rsvp" className="transition hover:text-gray-700">
                RSVP
              </a>
              <a href="#contact" className="transition hover:text-gray-700">
                Contact
              </a>
            </div>
          </div>
        </div>
      </nav>

      <section
        id="hero"
        className="relative flex h-screen items-center justify-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1469371670807-013ccf25f16a?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Grayscale background image */}
        <div className="absolute inset-0 grayscale filter"></div>
        {/* White overlay */}
        <div className="absolute inset-0 bg-white opacity-50"></div>
        <div className="relative px-4 text-center">
          <h1 className="mb-4 text-5xl font-extrabold drop-shadow">
            Welcome to Our Wedding
          </h1>
          <p className="mb-8 text-xl drop-shadow">
            Join us as we celebrate our love and union.
          </p>
          <a
            href="#rsvp"
            className="inline-block rounded-full bg-black px-6 py-3 text-white transition hover:bg-gray-800"
          >
            RSVP Now
          </a>
        </div>
      </section>

      {/* SVG Wave Divider */}
      <div className="w-full overflow-hidden leading-none">
        <svg
          viewBox="0 0 500 150"
          preserveAspectRatio="none"
          className="h-20 w-full"
        >
          <path
            d="M0,50 C150,150 350,0 500,50 L500,150 L0,150 Z"
            className="fill-gray-100"
          ></path>
        </svg>
      </div>

      {/* 2. About Us Section */}
      <section id="about" className="px-4 py-16">
        <div className="mx-auto flex max-w-5xl flex-col items-center md:flex-row">
          <div className="mb-8 md:mb-0 md:w-1/2">
            <img
              src="https://images.unsplash.com/photo-1634729108619-3576b0db8090?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Couple Portrait"
              className="transform rounded-lg shadow-lg transition duration-300 hover:scale-105"
            />
          </div>
          <div className="md:w-1/2 md:pl-12">
            <h2 className="mb-4 text-4xl font-bold">About Us</h2>
            <p className="text-lg leading-relaxed">
              We are two souls brought together by fate and passion. Our journey
              has been filled with adventures, laughter, and tender moments that
              have shaped our love story.
            </p>
          </div>
        </div>
      </section>

      {/* 3. Our Story Section */}
      <section id="story" className="bg-gray-100 px-4 py-16">
        <div className="mx-auto max-w-5xl">
          <h2 className="mb-8 text-center text-4xl font-bold">Our Story</h2>
          <div className="space-y-8">
            <div className="flex flex-col items-center md:flex-row">
              <div className="md:w-1/3">
                <h3 className="text-2xl font-semibold">How We Met</h3>
              </div>
              <div className="md:w-2/3">
                <p>
                  In a serendipitous moment, our eyes met and a spark ignited—a
                  spark that has grown into a beautiful journey of love.
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center md:flex-row">
              <div className="md:w-1/3">
                <h3 className="text-2xl font-semibold">The First Date</h3>
              </div>
              <div className="md:w-2/3">
                <p>
                  A casual coffee date turned into hours of heartfelt
                  conversation and laughter, setting the stage for our future.
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center md:flex-row">
              <div className="md:w-1/3">
                <h3 className="text-2xl font-semibold">The Proposal</h3>
              </div>
              <div className="md:w-2/3">
                <p>
                  Under a starlit sky, a promise was made—a promise of forever
                  that we sealed with a tender kiss.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. Gallery Section */}
      <section id="gallery" className="px-4 py-16">
        <div className="mx-auto max-w-6xl">
          <h2 className="mb-8 text-center text-4xl font-bold">Gallery</h2>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
            <img
              src="https://images.unsplash.com/photo-1583939003579-730e3918a45a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
              alt="Wedding Moment 1"
              className="h-64 w-full transform rounded-lg object-cover shadow-lg transition hover:scale-105"
            />
            <img
              src="https://images.unsplash.com/photo-1511285560929-80b456fea0bc?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
              alt="Wedding Moment 2"
              className="h-64 w-full transform rounded-lg object-cover shadow-lg transition hover:scale-105"
            />
            <img
              src="https://images.unsplash.com/photo-1519225421980-715cb0215aed?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
              alt="Wedding Moment 3"
              className="h-64 w-full transform rounded-lg object-cover shadow-lg transition hover:scale-105"
            />
            <img
              src="https://images.unsplash.com/photo-1469371670807-013ccf25f16a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
              alt="Wedding Moment 4"
              className="h-64 w-full transform rounded-lg object-cover shadow-lg transition hover:scale-105"
            />
            <img
              src="https://images.unsplash.com/photo-1522673607200-164d1b6ce486?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
              alt="Wedding Moment 5"
              className="h-64 w-full transform rounded-lg object-cover shadow-lg transition hover:scale-105"
            />
            <img
              src="https://images.unsplash.com/photo-1583939003579-730e3918a45a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
              alt="Wedding Moment 6"
              className="h-64 w-full transform rounded-lg object-cover shadow-lg transition hover:scale-105"
            />
          </div>
        </div>
      </section>

      {/* 5. Event Details Section */}
      <section id="events" className="px-4 py-16">
        <div className="mx-auto max-w-5xl text-center">
          <h2 className="mb-8 text-4xl font-bold">Event Details</h2>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            <div className="rounded-lg border p-6 shadow-md transition hover:shadow-xl">
              <h3 className="mb-2 text-2xl font-semibold">Ceremony</h3>
              <p>Date: June 25, 2025</p>
              <p>Time: 4:00 PM</p>
              <p>Location: St. Mary's Church</p>
            </div>
            <div className="rounded-lg border p-6 shadow-md transition hover:shadow-xl">
              <h3 className="mb-2 text-2xl font-semibold">Reception</h3>
              <p>Date: June 25, 2025</p>
              <p>Time: 7:00 PM</p>
              <p>Location: Grand Ballroom, City Hotel</p>
            </div>
          </div>
        </div>
      </section>

      {/* 6. RSVP Section */}
      <section id="rsvp" className="px-4 py-16">
        <div className="mx-auto max-w-xl text-center">
          <h2 className="mb-6 text-4xl font-bold">RSVP</h2>
          <p className="mb-8 text-lg">
            Please let us know if you'll be joining our celebration.
          </p>
          <form className="space-y-4">
            <input
              type="text"
              placeholder="Your Name"
              className="w-full rounded border border-gray-400 p-3 transition focus:outline-none focus:ring-2 focus:ring-gray-500"
            />
            <input
              type="email"
              placeholder="Your Email"
              className="w-full rounded border border-gray-400 p-3 transition focus:outline-none focus:ring-2 focus:ring-gray-500"
            />
            <textarea
              placeholder="Message"
              className="w-full rounded border border-gray-400 p-3 transition focus:outline-none focus:ring-2 focus:ring-gray-500"
            ></textarea>
            <button
              type="submit"
              className="w-full rounded bg-black py-3 text-white transition hover:bg-gray-800"
            >
              Submit
            </button>
          </form>
        </div>
      </section>

      {/* 7. Contact Section */}
      <section id="contact" className="bg-gray-100 px-4 py-16">
        <div className="mx-auto max-w-5xl text-center">
          <h2 className="mb-8 text-4xl font-bold">Contact</h2>
          <p className="mb-4">
            For any inquiries or additional information, please reach out to us.
          </p>
          <p>Email: team@tailwine.in</p>
          <p>Phone: (123) 456-7890</p>
        </div>
      </section>

      {/* 8. Footer */}
      <footer className="border-t border-gray-300 bg-white py-4 text-center">
        Made with <Heart className="inline h-4 w-4 text-rose-600" /> for our
        special day by Tailwine Studio
      </footer>
    </div>
  );
}
